// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__sQawo","title":"BackImages_title__HDgvC","images":"BackImages_images__1OqBe"};